export default {
  name: 'OrderList',
  data() {
    return {
      orders: []
    };
  },
  methods: {
    getCustMonOrder() {
      // let customer = this.$route.params.customer;
      // 查询用户一个月内订单
      let url = '/customer/main/order/order-list';
      this.$axios.post(url, {}).then(resp => {
        console.log(resp.data.list);
        this.orders = resp.data.list;
      });
    }
  },
  mounted() {
    this.getCustMonOrder();
  }
};